import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CreateAsset from "./CreateAsset";
import type { Asset } from "../../types/deal";
import { apiGetById } from "../../services/genesisApi/httpsMethods";
import { CircularProgress, Box } from "@mui/material";

const EditAssetWrapper = () => {
  const { assetId } = useParams();
  const [asset, setAsset] = useState<Partial<Asset>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAsset = async () => {
      try {
        const response = await apiGetById("asset", Number(assetId)); // API call
        if (response && response.success && response.data) {
          const data = response.data;
          setAsset(data[0]);
        }
      } catch (error) {
        console.error("Failed to fetch asset", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAsset();
  }, [assetId]);

  if (loading) {
    return (
      <Box sx={{ p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <CreateAsset asset={asset} isEdit={true} />;
};

export default EditAssetWrapper;
